var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpervaWaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(1 1)",
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05229 7.41699H6.5V8.89941H8.05229V7.41699Z",
    fill: "#FFFFFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05229 14.906H6.5V9.59121H8.05229V14.906ZM15.1882 9.4814C16.335 9.4814 17.0185 10.2391 17.0185 11.447V14.906H15.4778V11.7435C15.4778 11.1725 15.2114 10.7991 14.6785 10.7991C14.273 10.7991 13.9139 11.0407 13.8212 11.4909V14.917H12.2574V11.7435C12.2574 11.1725 12.0025 10.7991 11.4696 10.7991C11.0642 10.7991 10.6935 11.0407 10.6008 11.4909V14.917H9.06012V9.59121H10.6124V10.0304C10.8904 9.70102 11.4001 9.47042 12.0141 9.47042C12.6744 9.47042 13.2073 9.75592 13.5085 10.1512C13.8676 9.76691 14.4005 9.4814 15.1882 9.4814Z",
    fill: "#FFFFFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0185 15.5978V17.0802H15.4662V15.5978H17.0185Z",
    fill: "#FFFFFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpervaWaf);
export default __webpack_public_path__ + "static/media/ImpervaWAF.17113c9de2e909ec7ea4eedf2a38249b.svg";
export { ForwardRef as ReactComponent };